import { Button, Card, Form, Input, InputNumber, message, Select, Space, Alert } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { useAssignTicketMutation, useGetAllPoolsQuery, useGetCategoriesByPoolQuery } from './lotteryAPI';
import { useGetAllMemberQuery } from '../member/membersAPI';

function AssignLotteryTicket() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectedPoolId, setSelectedPoolId] = React.useState<number | null>(null);
  const [selectedCategoryId, setSelectedCategoryId] = React.useState<number | null>(null);

  const { data: pools, isLoading: isLoadingPools } = useGetAllPoolsQuery();
  const { data: categories, isLoading: isLoadingCategories } = useGetCategoriesByPoolQuery(selectedPoolId!, {
    skip: !selectedPoolId,
  });
  const { data: memberListData, isLoading: isLoadingMembers } = useGetAllMemberQuery(true);

  const [assignTicket, { isLoading: isAssigning }] = useAssignTicketMutation();

  const onFinish = async (values: any) => {
    try {
      const selectedCategory = categories?.find((c) => c.id === selectedCategoryId);
      if (!selectedCategory) {
        message.error('Silakan pilih kategori');
        return;
      }

      const ticketsToCreate = selectedCategory.maxTickets;

      // Create tickets one by one
      for (let i = 0; i < ticketsToCreate; i++) {
        await assignTicket(values).unwrap();
      }

      message.success(`${ticketsToCreate} tiket berhasil diberikan`);
      form.resetFields();
      setSelectedPoolId(null);
      setSelectedCategoryId(null);
    } catch (err: any) {
      message.error(err.data?.message || 'Gagal memberikan tiket');
    }
  };

  return (
    <ContentWithErrorHandler isError={false} isLoading={false}>
      <Card title="Berikan Tiket Undian ke Anggota" size="small">
        <Form form={form} layout="vertical" onFinish={onFinish} style={{ maxWidth: 600 }}>
          <Form.Item label="ID Anggota" name="memberId" rules={[{ required: true, message: 'Silakan pilih anggota' }]}>
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Pilih anggota"
              optionFilterProp="label"
              loading={isLoadingMembers}
              options={memberListData?.map((member) => ({
                label: `${member.memberId} - ${member.name}`,
                value: member.memberId,
              }))}
            />
          </Form.Item>

          <Form.Item label="Undian" name="poolId" rules={[{ required: true, message: 'Silakan pilih undian' }]}>
            <Select
              placeholder="Pilih undian"
              loading={isLoadingPools}
              options={pools?.map((pool) => ({
                label: pool.name,
                value: pool.id,
              }))}
              onChange={(value) => {
                setSelectedPoolId(value);
                form.setFieldValue('categoryId', undefined);
              }}
            />
          </Form.Item>

          <Form.Item label="Kategori" name="categoryId" rules={[{ required: true, message: 'Silakan pilih kategori' }]}>
            <Select
              placeholder="Pilih kategori"
              loading={isLoadingCategories}
              disabled={!selectedPoolId}
              onChange={(value) => {
                setSelectedCategoryId(value);
              }}
              options={categories?.map((category) => ({
                label: `${category.categoryId} - ${category.name}`,
                value: category.id,
              }))}
            />
          </Form.Item>

          {selectedCategoryId && (
            <Alert
              message={`Tiket yang akan diberikan: ${categories?.find((c) => c.id === selectedCategoryId)?.maxTickets || 0} tiket`}
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <Form.Item label="Catatan" name="notes">
            <Input.TextArea placeholder="Catatan opsional untuk tiket ini" rows={3} />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={isAssigning}>
                Berikan Tiket
              </Button>
              <Button onClick={() => navigate('/lottery/pools')}>Kembali</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ContentWithErrorHandler>
  );
}

export default AssignLotteryTicket;
